import { Switch } from '@audio-network/componentlibrary'
import { useTranslation } from 'next-i18next'
import React, { FormEvent } from 'react'
import { useToggleRefinement } from 'react-instantsearch'

import styles from './VocalFilter.module.css'

const VocalFilter = (): JSX.Element => {
	const { t } = useTranslation(['search'])

	const { value, refine } = useToggleRefinement({ attribute: 'Vocal' })
	const { refine: instrumentalRefine } = useToggleRefinement({
		attribute: 'Instrumental',
	})

	const toggleVocals = (event: FormEvent): void => {
		refine({ isRefined: !(event.target as HTMLInputElement).checked })
		if ((event.target as HTMLInputElement).checked === true) {
			instrumentalRefine({
				isRefined: true,
			})
		}
	}
	return (
		<Switch
			checked={value.isRefined}
			className={styles.switch}
			data-testid="vocal-switch"
			label={t('vocals-toggle')}
			onChange={toggleVocals}
		/>
	)
}

export default VocalFilter
